import _ from 'lodash';

export const DEFAULT_TITLE_PAGE = 'Nautica Assistance';

export const setTitlePage = ({ pathname, label, state }) => {
  const idOrAction = _.toUpper(pathname?.split('/')[3]);
  const action = _.toUpper(pathname?.split('/')[4]);

  document.title = DEFAULT_TITLE_PAGE;

  if (!label || label === '') {
    let page = _.toUpper(pathname?.split('/')[1]);
    let actionOrID = _.toUpper(pathname?.split('/')[2]);

    if (page === 'DEPARTMENT' && actionOrID !== '') {
      page = actionOrID
      actionOrID = _.toUpper(pathname?.split('/')[3]);
    }

    if (page === 'CUSTOMERS' || page === 'SUPPLIERS' || page === 'NA') {
      page = 'DIRECTORY - ' + page;
    }

    if (page === 'DISPATCH_BOARD') {
      page = 'DISPATCH BOARD';
    }

    if (page === 'OPERATIONS-LIST') {
      page = 'OPERATIONS';
    }

    const title = actionOrID && actionOrID !== ''
      ? `${page} - ${(idOrAction === 'EDIT' ? 'EDIT ' : '')}${!isNaN(actionOrID) ? `ID: ${actionOrID}` : actionOrID}`
      : page;

    document.title = title || DEFAULT_TITLE_PAGE;
  }

  if (idOrAction && idOrAction !== 'ADD' && action !== 'EDIT') {
    const department = _.toUpper(pathname?.split('/')[2]);
    const title =
      label ||
      (state?.yachtName
        ? `${state?.yachtName} ${state?.orderType ? ` - ${state?.orderType}` : ''}`
        : null);
    switch (department) {
      case 'PROVISIONS':
      case 'INTERIORS':
        document.title = title || DEFAULT_TITLE_PAGE;
        break;
      default:
        return;
    }
  }
};
